<script lang="ts">
    import MainLayout from "../#common/layout/Layout.svelte"
    import {showAlert} from "src/components/cabinet/#common/alert/store"
    import Alert from 'src/components/cabinet/#common/alert/Alert.svelte'
    import {verifyCode, disableTwoFactorRequest} from 'src/components/cabinet/#services/twoFactorAuthentication'

    let twoFaCode
    let verifySending = false
    let lostDeviceSending = false

    async function verifyCodeHandler() {
        try {
            verifySending = true
            await verifyCode.request({ data: { code: twoFaCode } })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            verifySending = false
        }
    }

    async function lostDeviceHandler() {
        try {
            lostDeviceSending = true

            await disableTwoFactorRequest.request()

            showAlert.set({
                status: 'success',
                text: 'We have sent an email confirming the deletion of the 2FA'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            lostDeviceSending = false
        }
    }
</script>

<MainLayout>
    <svelte:fragment slot="content">
        <div class="cabinet-wrapper">
            <Alert/>
            <div class="page-title">Please enter 2FA code</div>
            <div class="text">Two-factor authentication (2FA) is enabled for your account. Please enter a code to log in.</div>
            <input type="text" class="form-control qr-code-field" bind:value={twoFaCode} placeholder="Enter 2FA code">
            <button class="btn btn-primary" class:loading={verifySending} on:click={verifyCodeHandler}><span>Verify</span></button>
            <div class="text-center">
                <button class="btn lost-device-btn" class:loading={lostDeviceSending} on:click={lostDeviceHandler}
                    disabled={lostDeviceSending}>Lost your authentication device?</button>
            </div>
        </div>
    </svelte:fragment>
</MainLayout>

<style>
    .text {
        margin: 90px auto 30px;
        text-align: center;
        max-width: 450px;
    }

    .qr-code-field {
        max-width: 250px;
        text-align: center;
        box-shadow: inset 0 0 0 2px #c2c2c3;
        margin: 10px auto 22px;
    }

    .btn-primary {
        display: table;
        min-width: 250px;
        margin: 0 auto;
    }

    .lost-device-btn {
        background: none !important;
        border: 0;
        color: #afb1b3;
        font-size: 15px;
        margin: 15px 0 0;
        transition: .25s;
        box-shadow: none !important;
    }

    .lost-device-btn:hover {
        color: #cfd1d2;
    }

    @media(max-width: 768px) {
        .text {
            margin: 30px auto;
        }
    }
</style>
